import React, { useState, useEffect, useContext } from 'react'
import { FiChevronRight } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import {
    Tab, Tabs, TabList, TabPanel
} from 'react-tabs'
import { toast } from 'react-toastify'

import { api } from '~/services/api'

import scrollUtils from '~/util/scroll'

import Card from '~/components/Card'

import FormPessoal from '~/forms/Pessoal'
import FormPessoalAcademico from '~/forms/PessoalAcademico'
import FormContatos from '~/forms/Contatos'
import FormEndereco from '~/forms/Endereco'
import FormLocaisTrabalho from '~/forms/LocaisTrabalho'
import DadosAcademicos from '~/forms/DadosAcademicos'
import FormFinanceiro from '~/forms/Financeiro'

import { Container, ExpanderTab, ImageSelect } from './styles'

import medico from '~/assets/images/medico.png'
import academica from '~/assets/images/medica.png'
import { TipContext } from '~/contexts/TipContext'
import { loadTips } from '~/util/tip'

const idsContatosTelefonicos = [1, 2, 3, 4, 5]

export default function () {
    const history = useHistory()

    const { setCodigo } = useContext(TipContext)

    const [tabsStatus, setTabsStatus] = useState([true, false, false, false, false])
    const [indiceTabAtiva, setIndiceTabAtiva] = useState(0)
    const [categoria, setCategoria] = useState(null)

    useEffect(() => {
        localStorage.removeItem('sindmepa-associacao-temp-data')

        loadTips(setCodigo, 'form_associacao')
    }, [])

    useEffect(() => {
        setTabsStatus(categoria === 'academico' ? [true, false, false, false] : [true, false, false, false, false])
        setIndiceTabAtiva(0)
    }, [categoria])

    async function loadStoredData(identificador, setDadosPessoais) {
        const storageData = await api.get(`dados_associacao/${identificador.toString() /* .replaceAll(/\.|-/gi, '') */}`)

        if (!storageData?.dados) {
            return
        }

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storageData.dados))

        const {
            dados: {
                academico, pessoal, contatos, endereco, locais_trabalho, dados_academicos
            }
        } = storageData

        let tabSelecionada = 0

        if (pessoal) {
            tabSelecionada++
        }
        if (contatos && contatos.find(c => idsContatosTelefonicos.includes(c.tipo_contato))) {
            tabSelecionada++
        }
        if (endereco) {
            tabSelecionada++
        }
        if (!academico && locais_trabalho?.length) {
            tabSelecionada++
        }
        if (academico && dados_academicos) {
            tabSelecionada++
        }

        setTabsStatus(tabsStatus.map((_, index) => index <= tabSelecionada))

        setDadosPessoais(storageData.dados?.pessoal)
    }

    async function handleNextStep(enableNext = true) {
        if (indiceTabAtiva === tabsStatus.length - 1) {
            return
        }

        const proximaTabIndice = indiceTabAtiva + 1

        if (enableNext) {
            setTabsStatus([...tabsStatus.slice(0, proximaTabIndice), true, ...tabsStatus.slice(proximaTabIndice + 1)])
            setIndiceTabAtiva(proximaTabIndice)

            const storageData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

            await api.put(`dados_associacao/${storageData.pessoal[storageData.academico ? 'cpf' : 'crm'].toString() /* .replace(/[.-]/g, '') */}`, storageData)
        } else if (tabsStatus[proximaTabIndice]) {
            setIndiceTabAtiva(proximaTabIndice)
        }
    }

    async function concluirForm() {
        toast.success('Associação concluída! Enviaremos um e-mail de confirmação.')

        localStorage.removeItem('sindmepa-associacao-temp-data')

        history.push('/')
    }

    function handleCategoriaChange(value) {
        setCategoria(value)
        scrollUtils.toElement('nav')

        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({
            academico: value === 'academico'
        }))
    }

    return (
        <Container>
            <main className="animated fadeIn faster">
                <Card>
                    {categoria === null ? (
                        <h1>Selecione sua categoria</h1>
                    ) : (
                        <h1>
                            {categoria === 'academico' ? (
                                <>Associação de Acadêmico</>
                            ) : (
                                <>Associação de Médico</>
                            )}
                        </h1>
                    )}

                    <ImageSelect academico={categoria}>
                        <img
                            src={medico}
                            alt=""
                            className="medico"
                            onClick={() => { handleCategoriaChange('medico') }}
                        />

                        <img
                            src={academica}
                            alt=""
                            className="academica"
                            onClick={() => { handleCategoriaChange('academico') }}
                        />
                    </ImageSelect>

                    {categoria === null ? (
                        <></>
                    ) : categoria === 'academico' ? (
                        // Associação de Acadêmicos
                        <Tabs
                            selectedIndex={indiceTabAtiva}
                            onSelect={indiceTab => setIndiceTabAtiva(indiceTab)}
                        >
                            <TabList>
                                <Tab>1 - Dados pessoais</Tab>
                                <Tab disabled={!tabsStatus[1]}>2 - Contato</Tab>
                                <Tab disabled={!tabsStatus[2]}>3 - Endereço</Tab>
                                <Tab disabled={!tabsStatus[3]}>4 - Dados acadêmicos</Tab>
                                {indiceTabAtiva < 4 && (
                                    <ExpanderTab onClick={() => handleNextStep(false)} role="button" tabIndex={0}>
                                        <div className="expander-tab">
                                            <FiChevronRight />
                                        </div>
                                    </ExpanderTab>
                                )}
                            </TabList>

                            <TabPanel>
                                <FormPessoalAcademico callback={handleNextStep} loadStoredData={loadStoredData} />
                            </TabPanel>

                            <TabPanel>
                                <FormContatos callback={handleNextStep} />
                            </TabPanel>

                            <TabPanel>
                                <FormEndereco callback={handleNextStep} />
                            </TabPanel>

                            <TabPanel>
                                <DadosAcademicos callback={concluirForm} />
                            </TabPanel>
                        </Tabs>
                    ) : (
                        // Associação de Médicos
                        <Tabs
                            selectedIndex={indiceTabAtiva}
                            onSelect={indiceTab => setIndiceTabAtiva(indiceTab)}
                        >
                            <TabList>
                                <Tab>1 - Dados pessoais</Tab>
                                <Tab disabled={!tabsStatus[1]}>2 - Contato</Tab>
                                <Tab disabled={!tabsStatus[2]}>3 - Endereço residencial</Tab>
                                <Tab disabled={!tabsStatus[3]}>4 - Locais de trabalho</Tab>
                                <Tab disabled={!tabsStatus[4]}>5 - Financeiro</Tab>
                                {indiceTabAtiva < 4 && (
                                    <ExpanderTab onClick={() => handleNextStep(false)} role="button" tabIndex={0}>
                                        <div className="expander-tab">
                                            <FiChevronRight />
                                        </div>
                                    </ExpanderTab>
                                )}
                            </TabList>

                            <TabPanel>
                                <FormPessoal callback={handleNextStep} loadStoredData={loadStoredData} />
                            </TabPanel>

                            <TabPanel>
                                <FormContatos callback={handleNextStep} />
                            </TabPanel>

                            <TabPanel>
                                <FormEndereco callback={handleNextStep} />
                            </TabPanel>

                            <TabPanel>
                                <FormLocaisTrabalho callback={handleNextStep} />
                            </TabPanel>

                            <TabPanel>
                                <FormFinanceiro callback={concluirForm} />
                            </TabPanel>
                        </Tabs>
                    )}
                </Card>
            </main>
        </Container>
    )
}
